// (c) 2026 Owl Consultations. All rights reserved.
// Proprietary and confidential — licensed use only.

// D-COST-6 rollout: /admin/profitability shows the Current page and the v2 (beta) page side by side.
// Current is untouched; it is deleted, along with CostTab, once v2 reaches parity.

import { useSearchParams } from 'react-router-dom'
import Box from '@mui/material/Box'
import AppTabs from '../../components/ui/AppTabs'
import ErrorBoundary from '../../components/ui/ErrorBoundary'
import ProfitabilityTab from './ProfitabilityTab'
import FinanceV2Tab from './finance/FinanceV2Tab'

export default function ProfitabilityPage() {
  const [params, setParams] = useSearchParams()
  const view = params.get('view') === 'v2' ? 'v2' : 'current'
  return (
    <Box>
      <AppTabs value={view} ariaLabel="Profitability version" onChange={v => setParams(v === 'v2' ? { view: 'v2' } : {}, { replace: true })}
        tabs={[{ value: 'current', label: 'Current' }, { value: 'v2', label: 'v2', badge: 'beta' }]} />
      {/* A v2 render failure must never blank the admin console: the Current tab and the sidebar stay reachable. */}
      {view === 'v2'
        ? <Box sx={{ px: 2.75, py: 2.25 }}><ErrorBoundary what="Profitability v2" resetKey={params.toString()}><FinanceV2Tab /></ErrorBoundary></Box>
        : <ProfitabilityTab />}
    </Box>
  )
}
